import { useState, useEffect, useRef } from 'react';
import { playTickSound, playStartSound } from '@/pages/dsst-spick/utils/sound';

interface CountdownScreenProps {
  onComplete: () => void;
}

export default function CountdownScreen({ onComplete }: CountdownScreenProps) {
  const [display, setDisplay] = useState<string>('3');
  const doneRef = useRef(false);

  useEffect(() => {
    const steps = ['3', '2', '1', '시작!'];
    let i = 0;
    setDisplay(steps[0]);
    playTickSound();
    const interval = setInterval(() => {
      i += 1;
      if (i < steps.length) {
        setDisplay(steps[i]);
        if (steps[i] === '시작!') playStartSound();
        else playTickSound();
      } else {
        clearInterval(interval);
        if (!doneRef.current) {
          doneRef.current = true;
          onComplete();
        }
      }
    }, 900);
    return () => clearInterval(interval);
  }, [onComplete]);

  const isStart = display === '시작!';

  return (
    <div className="flex flex-col h-full items-center justify-center bg-white px-6 animate-fade-in-up">
      {!isStart && (
        <p className="text-[19px] font-bold text-foreground-900 text-center leading-snug mb-10">
          45초 동안
          <br />
          최대한 많이 맞춰보세요!
        </p>
      )}
      {isStart ? (
        <span className="text-6xl font-extrabold text-accent-500 animate-pop-in whitespace-nowrap">
          시작!
        </span>
      ) : (
        <div
          key={display}
          className="w-32 h-32 flex items-center justify-center rounded-full bg-primary-50 border border-primary-100 animate-pop-in"
        >
          <span className="text-6xl font-extrabold text-primary-500 leading-none">{display}</span>
        </div>
      )}
    </div>
  );
}